import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const SiteStatusNotAvailableGlyph = /*#__PURE__*/createElement("g", {
  id: "site_status_not_available",
  fill: "none",
  style: {
    transform: 'scale(2.5)'
  }
}, /*#__PURE__*/createElement("ellipse", {
  opacity: "0.2",
  cx: "16",
  cy: "16.3433",
  rx: "16",
  ry: "16.3433",
  fill: "#E2000F"
}), /*#__PURE__*/createElement("ellipse", {
  cx: "16.0001",
  cy: "16.3436",
  rx: "12.6316",
  ry: "12.9026",
  fill: "white"
}), /*#__PURE__*/createElement("ellipse", {
  cx: "16",
  cy: "16.3433",
  rx: "9.26316",
  ry: "9.46194",
  fill: "#E2000F"
}));
const SiteStatusNotAvailable = createSvg({
  name: 'site_status_not_available',
  path: SiteStatusNotAvailableGlyph
});

export default SiteStatusNotAvailable;
export { SiteStatusNotAvailableGlyph };
